export default {
  state: {
    installed: [],
    list: [
      { name: 'Facebook', link: '', icon: 'facebook' },
      { name: 'Twitter', link: '', icon: 'twitter' }
    ]
  },
  getters: {
    socials: state => state.installed,
    socialsLink: state => state.installed.link,
  },
  mutations: {
    ADD_SOCIAL (state, data) {
      const index = state.installed.findIndex(i => i.name === data.name)
      if (index === -1) state.installed.push(data)
    },
    REMOVE_SOCIAL (state, index) {
      state.installed.splice(index, 1)
    },
    SET_SOCIAL (state, { index, data }) {
      state.installed[index].link = data
    },
    SET_SOCIAL_STATE (state, data) {
      state = Object.assign(state, data)
    },
    SET_INSTALLED_STATE (state, data) {
      state.installed = data
    },
    RESET_SOCIAL (state) {
      state.installed = []
    }
  },
  actions: {
    async addSocial ({ state, commit, dispatch, rootState }, data) {
      commit('ADD_SOCIAL', data)
      await dispatch('updateProject', rootState.projects.project)
    },
    async removeSocial ({ state, commit, dispatch, rootState }, index) {
      commit('REMOVE_SOCIAL', index)
      await dispatch('updateProject', rootState.projects.project)
    },
    async updateSocial ({ commit, dispatch, rootState }, { index, data }) {
      commit('SET_SOCIAL', { index, data })
      await dispatch('updateProject', rootState.projects.project)
    },
    async updateSort ({ state, commit, dispatch, rootState }, data) {
      commit('SET_INSTALLED_STATE', data)
      await dispatch('updateProject', rootState.projects.project)
    }
  }
}